import { Icon } from '@chakra-ui/react';

export const IconWinCustomers = () => (
  <Icon viewBox="0 0 30 50" boxSize={'3em'}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.334 4.5a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25Zm-9.375 5.625a9.375 9.375 0 1 1 18.75 0 9.375 9.375 0 0 1-18.75 0ZM4.239 34.5h22.189c-.893-5.32-5.52-9.375-11.095-9.375-5.574 0-10.201 4.054-11.094 9.375ZM.333 36.375c0-8.284 6.716-15 15-15 8.285 0 15 6.716 15 15 0 1.035-.839 1.875-1.874 1.875H2.209a1.875 1.875 0 0 1-1.876-1.875Z"
      fill="#4ADB95"
    />
  </Icon>
);

export const IconSellMore = () => (
  <Icon viewBox="0 0 40 50" boxSize={'3em'}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.25 2.625C.25 1.589 1.09.75 2.125.75h3.75c.894 0 1.663.63 1.839 1.507L8.162 4.5h27.713a1.875 1.875 0 0 1 1.677 2.714l-7.5 15a1.875 1.875 0 0 1-1.677 1.036H10.402L6.652 27h21.723a5.625 5.625 0 1 1-5.305 3.75h-8.14a5.625 5.625 0 1 1-10.352-.612c-1.836-1.22-2.377-3.99-.578-5.79l3.59-3.59L4.338 4.5H2.125A1.875 1.875 0 0 1 .25 2.625ZM11.162 19.5h16.054l5.625-11.25H8.912l2.25 11.25ZM9.625 30.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Zm18.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Z"
      fill="#4ADB95"
    />
  </Icon>
);

export const IconIncreaseDisclosure = () => (
  <Icon viewBox="0 -10 40 50" boxSize={'3em'}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.542 4a1.875 1.875 0 0 1 0-3.75h15c1.035 0 1.875.84 1.875 1.875v15a1.875 1.875 0 0 1-3.75 0V6.652l-11.8 11.799a1.875 1.875 0 0 1-2.65 0l-6.175-6.174L4.118 22.2a1.875 1.875 0 1 1-2.652-2.652L12.716 8.3a1.875 1.875 0 0 1 2.652 0l6.174 6.174L32.015 4H21.542Z"
      fill="#4ADB95"
    />
  </Icon>
);
